// The same mapping is used for navigation state and direct/refresh project loads.
// Keep false values: they are explicit preferences, not missing fields.
export const emptySearchFilters = {
  event_type: '', expected_attendees: '', preferred_districts: [],
  preferred_neighborhoods: [], excluded_neighborhoods: [], excluded_districts: [],
  preferred_days: [], preferred_time_ranges: [], venue_budget_model: '', venue_budget_max_try: null, excluded_days: [],
  technical_needs: [], alcohol_needed: null, outside_materials_needed: null,
  table_setup_needed: null, needs_two_person_table_setup: null,
  min_table_size_expectation: null, needs_personal_workspace: null,
};

export const projectSearchFilters = (project = {}) => Object.fromEntries(
  Object.entries(emptySearchFilters).map(([key, fallback]) => {
    const value = project[key] ?? fallback;
    return [key, key === 'expected_attendees' ? String(value) : Array.isArray(value) ? [...value] : value];
  })
);

export const projectSearchPrefill = (project) => ({
  project_id: project.id,
  project_title: project.title,
  free_text: [project.title, project.description].filter(Boolean).join(' — '),
  ...projectSearchFilters(project),
});

export const mergeProjectSearchFilters = (current, project) => {
  const saved = projectSearchFilters(project);
  return Object.fromEntries(Object.keys(emptySearchFilters).map(key => {
    const value = current[key];
    const empty = value == null || value === '' || (Array.isArray(value) && value.length === 0);
    return [key, empty ? saved[key] : value];
  }));
};
